import React from 'react';
import getName from '../../../../helpers/getName';
import styles from './Author.module.scss';

const Author = ({ author }) => {
  return (
    <div>
      <span>{getName(author)}</span>
      {author.specialityName && (
        <span className={styles.speciality}> ({author.specialityName})</span>
      )}
    </div>
  );
};

export default Author;
